// A number the server has not worked out, rendered as the absence it is.
//
// Several fields on the view shapes became nullable on 2026-09-19 with E1,
// because a server is not a simulator: `player_projections` had no writer until
// Epic F (the ingest writes it since 2026-09-25; the reads serve it from N3), no
// news source has terms we may use, and a win probability is a
// function of projections that do not exist. The simulator fills all of them
// and always will; the API does not.
//
// THE POINT IS THAT NULL IS NOT ZERO. A projection of `0.0` says "we expect this
// player to score nothing", which is a claim about a player in the field a
// lineup decision is made on; `—` says nobody has worked it out. Substituting
// zero here would be precisely the silent fallback CLAUDE.md rules out, and it
// would be invisible — a screen full of confident zeros looks like a screen
// full of numbers.

/** What a not-computed number looks like. An em dash, not a zero and not "N/A". */
export const NOT_COMPUTED = '—';

/** A projection, a probability, a total: the number if there is one, the dash if not. */
export function num(value: number | null | undefined, digits = 1): string {
  return value === null || value === undefined ? NOT_COMPUTED : value.toFixed(digits);
}

/** A share out of 100 with its sign — "34%" — or the dash, never "—%" and never "0%". */
export function pct(value: number | null | undefined, digits = 0): string {
  return value === null || value === undefined ? NOT_COMPUTED : `${value.toFixed(digits)}%`;
}

/** A difference between two numbers, where either one missing makes the difference unknowable. */
export function diff(
  a: number | null | undefined,
  b: number | null | undefined,
  digits = 1,
): string {
  if (a === null || a === undefined || b === null || b === undefined) return NOT_COMPUTED;
  return (a - b).toFixed(digits);
}
